import styles from "./styles.module.scss";

const SkeletoneProductCard = () => {
  return (
    <div className={styles.skProdCard}>
      <div className={styles.image}></div>
      <div className={styles.title}></div>
      <div className={styles.size}></div>
      <div className={styles.price}></div>
      <div className={styles.price}></div>
    </div>
  )
}

export default SkeletoneProductCard